import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import RequestActions from '../components/RequestActions';
import { closeRequest } from '../actions';
import RequestPanel from '../components/RequestPanel';

export default (urls, access) => ({
  ...tabTemplate('request', RequestPanel, matchCodeUrl(urls), RequestActions),
  ...tabCloser('closeRequestTab', closeRequest),
  ...tabIcons('key'),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 510,
});
